
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import {saveEnterpriseSubsidy} from '@/api/service/index';
export default {

data() {
return {
info:'',
unitName:'',
registerCode:'',
licenceCode:''
};
},
/**
* The methods the page can use.
*/
methods: {
saveEnterpriseSubsidy(){
let params = {unitName:this.unitName,registerCode:this.registerCode,licenceCode:this.licenceCode}
saveEnterpriseSubsidy(params).then((res) => {
this.info = res.data;

})
},

},
mounted () {
this.unitName = this.$route.query.unitName;
this.registerCode = this.$route.query.registerCode;
this.licenceCode = this.$route.query.licenceCode;
this.saveEnterpriseSubsidy();
},
/**
* The components the page can use.
*/

};



// WEBPACK FOOTER //
// ./src/pages/wg/next.vue